// loader.interceptors.ts
import { Injectable } from '@angular/core';
import {
    HttpErrorResponse,
    HttpResponse,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoaderService } from '../services/loader/loader.service';
import { Router } from '@angular/router';
import { isTokenExpired } from './utility';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
    private requests: HttpRequest<any>[] = [];
 
    constructor(private loaderService: LoaderService, private router: Router) { }
 
    removeRequest(req: HttpRequest<any>) {
        const i = this.requests.indexOf(req);
        if (i >= 0) {
            this.requests.splice(i, 1);
        }
        this.loaderService.isLoading.next(this.requests.length > 0);
    }
 
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
              // Skip adding Authorization header for S3 presigned URLs
    if (req.url.includes('s3service.sconexsoft.com') || req.url.includes('amazonaws.com')) {
      return next.handle(req);
    }
    if (req.url.includes('/casa/api/auth/login')) {
      return next.handle(req);
    }
    if (req.url.includes('/casa')) {
            return next.handle(req);
        }
        const token = localStorage.getItem('token');
        if (token){
            if(!isTokenExpired(token)){
                const headers = new HttpHeaders({Authorization: `Bearer ${token}` });
                req = req.clone({headers});
            } else {
                localStorage.removeItem('token');
                this.router.navigate(['/logout']);
            }
        } else {
            this.router.navigate(['/login']);
        }
        
        this.requests.push(req);
        this.loaderService.isLoading.next(true);
        return Observable.create(observer => {
            const subscription = next.handle(req)
                .subscribe(
                    event => {
                        if (event instanceof HttpResponse) {
                            this.removeRequest(req);
                            observer.next(event);
                        }
                    },
                    err => {
                        // alert('error returned');
                        this.removeRequest(req);
                        observer.error(err);
                    },
                    () => {
                        this.removeRequest(req);
                        observer.complete();
                    });
            // remove request from queue when cancelled
            return () => {
                this.removeRequest(req);
                subscription.unsubscribe();
            };
        });
    }
}